import { createUseStyles } from 'react-jss'
import { mediumGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  targetingFieldWrapper: {
    marginTop: 24
  },
  allocationFieldsContainer: {
    display: 'grid',
    gridTemplateColumns: '200px 1fr',
    columnGap: 12,
    '& .field': {
      margin: 0
    }
  },
  earthIcon: {
    marginLeft: 12,
    width: 16,
    color: mediumGrey,

    '&:hover': {
      color: mediumGrey
    }
  }
})

export default useStyles
